import { UploadZone } from "./components/UploadZone.js";
import { Footer } from "./components/Footer.js";
import { LiveStats } from "./components/LiveStats.js";
import { MobileAnnouncement } from "./components/MobileAnnouncement.js";

export function App() {
  return (
    <main className="page">
      <BackgroundOrnament />
      <TopNav />
      <UploadZone />
      <LiveStats />
      <MobileAnnouncement />
      <Footer />
    </main>
  );
}

function TopNav() {
  return (
    <nav className="topnav">
      <a href="/analytics" className="topnav__link">
        Analytics <span aria-hidden="true">→</span>
      </a>
    </nav>
  );
}

function BackgroundOrnament() {
  return (
    <>
      <div className="orb orb--1" aria-hidden="true" />
      <div className="orb orb--2" aria-hidden="true" />
      <div className="grid" aria-hidden="true" />
    </>
  );
}
